import React, { FC, ReactNode, useContext } from 'react';
import { DataTableBodyRowContext } from '../../_BodyRow/context';

interface IDataTableCellValueRightHoverContentProps {
  children: ReactNode;

  rightContentCallback(): ReactNode;
}

export const DataTableCellModifierRightHoverContent: FC<IDataTableCellValueRightHoverContentProps> = ({
  children,
  rightContentCallback,
}) => {
  const rowCtx = useContext(DataTableBodyRowContext);

  return (
    <div style={{ display: 'flex', width: '100%', position: 'relative' }}>
      {children}
      <div
        style={{
          display: 'flex',
          position: 'absolute',
          right: '0px',
          top: '0px',
          background: '#fff',
          padding: '1px 4px',
        }}
      >
        {rowCtx.hovered && rightContentCallback()}
      </div>
    </div>
  );
};
